import React from 'react';

import { useAppSelector } from 'redux/hooks';
import { selectUser } from 'redux/auth';
import LoadingState from 'components/LoadingState';
import { exists } from 'lib/types';
import RegisterIndividualHeader from './RegisterIndividualHeader';
import RegisterIndividualForm from './RegisterIndividualForm';

export default function RegisterIndividual() {
  const user = useAppSelector(selectUser);
  if (!exists(user)) return <LoadingState />;
  return (
    <div className="w-200 mx-auto">
      <RegisterIndividualHeader />
      <RegisterIndividualForm user={user} />
    </div>
  );
}
